import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { CommandsRoutePage } from "../app/commandsRoute";

export const Route = createFileRoute("/commands")({
  component: CommandsRoute,
});

function CommandsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <CommandsRoutePage search={search} />;
}
